function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  ).filter((el) => {
    if (el.closest("[inert]")) return false;
    if (el.closest("[hidden]")) return false;
    if (el.getAttribute("aria-hidden") === "true") return false;
    // Skip elements that are not visible / not in the tab order (e.g. drawer
    // still visibility:hidden before .menu-opening is applied).
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  });
}

function waitForElement(selector, callback, interval = 100, timeout = 5000) {
  const startTime = Date.now();
  const timer = setInterval(function () {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(timer);
      callback(el);
    } else if (Date.now() - startTime > timeout) {
      clearInterval(timer);
    }
  }, interval);
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  // Keep keydown active for the whole trap lifetime and recompute first/last
  // on every Tab — Dawn's stale first/last + focusin-only listener caused Tab
  // to wrap early (stuck at search/close in the mobile drawer).
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;

    const elements = getFocusableElements(container);
    if (elements.length === 0) return;

    const first = elements[0];
    const last = elements[elements.length - 1];

    if (event.shiftKey) {
      if (event.target === first || !container.contains(event.target)) {
        event.preventDefault();
        last.focus();
      }
    } else if (event.target === last) {
      event.preventDefault();
      first.focus();
    }
  };

  document.addEventListener("keydown", trapFocusHandlers.keydown);

  const elements = getFocusableElements(container);
  const preferred =
    elementToFocus &&
    elementToFocus !== container &&
    elements.includes(elementToFocus)
      ? elementToFocus
      : elements[0];
  (preferred || container).focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    //this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll(".menu-top-close").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      // Do not set role="button" on <summary> — invalid per ARIA in HTML
      // when it is the disclosure control for its parent <details>.
      element.removeAttribute("role");
      element.setAttribute("aria-expanded", false);
      const controlled = element.nextElementSibling;
      if (controlled && controlled.id) {
        element.setAttribute("aria-controls", controlled.id);
      }
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    if (detailsElement === this.mainDetailsToggle) {
      log.debug(detailsElement);
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      log.debug(summaryElement.classList);
      if (
        summaryElement.classList.contains("menu-drawer__menu-item") &&
        !isOpen
      ) {
        log.debug("yeah");
        document
          .querySelectorAll(".menu-megamenu .menu-opening[open]")
          .forEach((el) => {
            el.removeAttribute("open");
          });
      }

      // Wait until the submenu is visible, then focus the first *visible*
      // control inside it. Focusing a display:none back button made
      // trapFocus fall back to the logo.
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        const submenu = summaryElement.nextElementSibling;
        const focusTarget =
          (submenu && getFocusableElements(submenu)[0]) || summaryElement;
        trapFocus(this.mainDetailsToggle, focusTarget);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    summaryElement.setAttribute("aria-expanded", true);
    // Keep hamburger out of the tab cycle while the drawer is open — close is
    // handled by .menu-top-close / Escape (full-viewport summary was trapping Tab).
    summaryElement.setAttribute("tabindex", "-1");
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      // Prefer first category (e.g. DESKS) so Tab continues through the menu;
      // fall back to close / search if the nav is empty.
      const focusEl =
        this.mainDetailsToggle.querySelector(
          ".menu-drawer__navigation summary.menu-drawer__menu-item, .menu-drawer__navigation a.menu-drawer__menu-item",
        ) ||
        this.mainDetailsToggle.querySelector(".menu-top-close") ||
        this.mainDetailsToggle.querySelector(".search_box") ||
        summaryElement;
      trapFocus(this.mainDetailsToggle, focusEl);
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      document
        .getElementById("header-drawer")
        ?.classList.remove("menu-opening-mm");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      const summary = this.mainDetailsToggle.querySelector("summary");
      summary.setAttribute("aria-expanded", false);
      summary.removeAttribute("tabindex");
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`,
      );
      removeTrapFocus(elementToFocus || summary);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (!this.mainDetailsToggle.hasAttribute("open")) return;
      if (this.mainDetailsToggle.contains(document.activeElement)) return;

      // Globo predictive search moves focus into its overlay; do not close the
      // drawer or leave focus on skip-link when that overlay is active.
      const active = document.activeElement;
      if (
        active &&
        active.closest(
          "#glFilter-search-popup, .glFilter-search-popup, .gl-fullscreen-layer",
        )
      ) {
        return;
      }

      this.closeMenuDrawer(
        this.mainDetailsToggle.querySelector("summary"),
      );
    });
  }

  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest("details");
    if (!detailsElement) return;

    if (detailsElement === this.mainDetailsToggle) {
      this.closeMenuDrawer(
        event.currentTarget,
        this.mainDetailsToggle.querySelector("summary"),
      );
    } else {
      this.closeSubmenu(detailsElement);
    }
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom",
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );

    summaryElement.setAttribute("aria-expanded", true);
    summaryElement.setAttribute("tabindex", "-1");
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      document.getElementById("header-drawer")?.classList.add("menu-opening-mm");
      const focusEl =
        this.mainDetailsToggle.querySelector(
          ".menu-drawer__navigation summary.menu-drawer__menu-item, .menu-drawer__navigation a.menu-drawer__menu-item",
        ) ||
        this.mainDetailsToggle.querySelector(".menu-top-close") ||
        this.mainDetailsToggle.querySelector(".search_box") ||
        summaryElement;
      trapFocus(this.mainDetailsToggle, focusEl);
    });
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this),
    );
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this),
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.scrollContainer = this.querySelector(".product-thumbnails-section");
    this.sliderSmall = this.querySelector(
      ".product-thumbnails-section ul.thumbnails-slider_mobile",
    );
    this.sliderItemsSmall = this.querySelectorAll(
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li",
    );
    this.oldPage;
    this.stableElements = [];

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener("scroll", this.update.bind(this));
    for (this.sliderItemSmall of this.sliderItemsSmall) {
      this.sliderItemSmall.addEventListener(
        "click",
        this.smallIndex.bind(this),
      );
      this.sliderItemSmall.addEventListener(
        "keydown",
        this.onThumbnailKeydown.bind(this),
      );
    }
    this.initSkipProductImages();

    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.prevButton.addEventListener("click", this.sliderMove.bind(this));
    this.nextButton.addEventListener("click", this.sliderMove.bind(this));

    // Thumb-strip arrows: always visible (unlike overflow-only scroll buttons). They drive
    // the same main-gallery prev/next as the overlay arrows on the hero, so the active
    // thumbnail / tab sync stays consistent via the existing sliderMove + scroll handlers.
    this.thumbsPrevButton = this.querySelector('button[name="thumbs-previous"]');
    this.thumbsNextButton = this.querySelector('button[name="thumbs-next"]');
    if (this.thumbsPrevButton && this.thumbsNextButton) {
      this.thumbsPrevButton.addEventListener(
        "click",
        this.onButtonClick.bind(this),
      );
      this.thumbsNextButton.addEventListener(
        "click",
        this.onButtonClick.bind(this),
      );
      this.thumbsPrevButton.addEventListener(
        "click",
        this.sliderMove.bind(this),
      );
      this.thumbsNextButton.addEventListener(
        "click",
        this.sliderMove.bind(this),
      );
    }
  }

  initSkipProductImages() {
    const skipBtn = this.querySelector(".js-skip-product-images");
    if (!skipBtn) return;

    const getAfterThumbsFocusable = () => {
      const targetId = skipBtn.getAttribute("data-skip-target");
      const fallbackId = skipBtn.getAttribute("data-skip-fallback");
      const target = targetId ? document.getElementById(targetId) : null;
      const fallback = fallbackId ? document.getElementById(fallbackId) : null;
      return (
        (target &&
          target.querySelector(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
          )) ||
        fallback
      );
    };

    skipBtn.addEventListener("click", () => {
      const focusable = getAfterThumbsFocusable();
      const fallbackId = skipBtn.getAttribute("data-skip-fallback");
      const fallback = fallbackId ? document.getElementById(fallbackId) : null;
      if (focusable) {
        focusable.focus();
        return;
      }
      if (fallback) {
        fallback.setAttribute("tabindex", "-1");
        fallback.focus();
      }
    });

    // Shift+Tab from first control after thumbs → skip button (not last photo)
    const afterFocusable = getAfterThumbsFocusable();
    if (afterFocusable) {
      afterFocusable.addEventListener("keydown", (event) => {
        if (event.key !== "Tab" || !event.shiftKey) return;
        event.preventDefault();
        skipBtn.focus();
      });
    }
  }

  onThumbnailKeydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    event.preventDefault();
    event.currentTarget.click();
  }

  smallIndex(event) {
    event.preventDefault?.();
    log.debug(
      document.getElementById("thumbnail-bottom-slider").childElementCount,
    );
    let position = jQuery(event.currentTarget).index();
    if (this.sliderItemsSmall?.length) {
      this.sliderItemsSmall.forEach((el) => {
        if (el.getAttribute("role") === "option") {
          el.setAttribute(
            "aria-selected",
            el === event.currentTarget ? "true" : "false",
          );
        }
      });
    }
    this.update(position);
    this.slider.scrollTo({
      left: position * this.sliderItems[0].clientWidth,
    });
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    if (!this.sliderItemsSmall.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth,
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update(position) {
    if (!this.pageCount || !this.pageTotal) return;
    // <gallery-tabs> (product-gallery-tabs.js) sets this while it's smooth-scrolling to a
    // tab's thumbnail itself. This component's own page/scroll math below doesn't know
    // about tab positions or hidden/duplicate thumbnails, so letting it also re-scroll the
    // bottom row at the same time fights the tab click and looks like an extra swipe.
    if (document.documentElement.hasAttribute("data-gallery-tab-scrolling")) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
      if (this.thumbsPrevButton) this.thumbsPrevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
      if (this.thumbsPrevButton) this.thumbsPrevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages / 2) {
      this.nextButton.setAttribute("disabled", true);
      if (this.thumbsNextButton) this.thumbsNextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
      if (this.thumbsNextButton) this.thumbsNextButton.removeAttribute("disabled");
    }
    var position;

    if (position) {
      this.pageCount.textContent = position;
      this.sliderMove(position);
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages / 2;
    this.sliderMove(this.currentPage, this.oldPage);
    this.oldPage = this.currentPage;
  }

  sliderMove(page, oldPage) {
    const currentPage = page - 1;
    const elementNot =
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li";
    jQuery(elementNot).removeClass("slider__active");
    const element =
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li:eq(" +
      currentPage +
      ")";

    this.sliderSmall.addEventListener("wheel", (evt) => {
      evt.preventDefault();
      this.sliderSmall.scrollLeft += evt.deltaY - 20;
    });

    jQuery(element).addClass("slider__active");

    let newCurrentItem = currentPage + 1;
    let oneStep = Math.floor(
      this.scrollContainer.clientWidth /
      (this.sliderItemsSmall[0].clientWidth + 3),
    );
    let singleElemetnScrollWidth = this.sliderItemsSmall[0].clientWidth + 3;
    let scrollL = singleElemetnScrollWidth * 2;
    let scrollR = singleElemetnScrollWidth * oneStep;

    if (page >= oldPage) {
      if (this.stableElements.includes(newCurrentItem)) {
      } else {
        this.sliderSmall.scrollTo({
          left: newCurrentItem * singleElemetnScrollWidth - scrollR,
        });
        for (let i = 0; i < oneStep - 2; i++) {
          this.stableElements[i] = page - i;
        }
      }
    } else if (page < oldPage) {
      if (this.stableElements.includes(newCurrentItem)) {
      } else {
        this.sliderSmall.scrollTo({
          left: newCurrentItem * singleElemetnScrollWidth - scrollL,
        });
        for (let i = 0; i < oneStep - 2; i++) {
          this.stableElements[i] = page + i;
        }
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const isNext =
      event.currentTarget.name === "next" ||
      event.currentTarget.name === "thumbs-next";
    const slideScrollPosition = isNext
      ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
      : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    //this.updatePickupAvailability();
    // log.debug(this.currentVariant);
    if (!this.currentVariant) {
      //this.toggleAddButton(true, '', true);
      // this.setUnavailable();
      // No full variant match yet — try to update image based on partial selection
      this.updateMediaPartial();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this._updatePrice();
      //this.renderProductInfo();
      var selectionData = document.querySelector(".selection-data");
      selectionData.dataset.prodVariantId = this.currentVariant.id;
      selectionData.dataset.prodPrice = this.currentVariant.price * 0.01;
      // log.debug(this.currentVariant);
      if (this.currentVariant.compare_at_price > 0) {
        if (selectionData.dataset.codeDiscount > 0) {
          var discount = selectionData.dataset.codeDiscount;
        } else {
          var discount =
            this.currentVariant.compare_at_price - this.currentVariant.price;
        }
      } else {
        var discount = 0;
      }
      selectionData.dataset.prodDiscount = discount * 0.01;
    }

    var allThumbSmallElement = document.querySelectorAll(
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li",
    );
    for (let i = 0; i < allThumbSmallElement.length; i++) {
      allThumbSmallElement[i].classList.remove("slider__active");
    }

    if (allThumbSmallElement[0]) {
      allThumbSmallElement[0].classList.add("slider__active");
    }
  }

  updateMediaPartial() {
    // Find first available variant that matches the currently selected (non-empty) options
    const partialMatch = this.getVariantData().find((variant) => {
      return this.options.every((option, index) => {
        return option === "" || option === variant.options[index];
      });
    });
    if (!partialMatch || !partialMatch.featured_media) return;

    // Same hero-slot content swap as updateMedia() -- this used to physically move DOM
    // nodes around instead (like updateMedia() originally did), which broke the fixed
    // `data-gallery-hero-slot`/`data-media-position` bookkeeping <gallery-tabs> relies on
    // as soon as a shopper picked an option combo that only partially matched a variant
    // (e.g. a line-item property like Leg Colour, selected before every real Shopify
    // option had a value) -- the very next tab click or hero update landed on the wrong
    // thumbnail, since positions no longer matched where the tabs/JS expected them.
    this._syncHeroSlot(
      document.getElementById("thumbnail-main-slider"),
      `${this.dataset.section}-${partialMatch.featured_media.id}`
    );
    this._syncHeroSlot(
      document.getElementById("thumbnail-bottom-slider"),
      `${this.dataset.section}bottom-${partialMatch.featured_media.id}`
    );
    document.dispatchEvent(new CustomEvent("gallery:hero-updated"));
  }

  // CUSTOM FOR BOLD (SHOPCIRCLE)
  _emitBoldVariantChange(variant) {
    if (
      typeof BOLD !== "undefined" &&
      typeof BOLD.common !== "undefined" &&
      typeof BOLD.common.eventEmitter !== "undefined"
    ) {
      BOLD.common.eventEmitter.emit("BOLD_COMMON_variant_changed", { variant });
    }
  }
  // CUSTOM FOR BOLD (SHOPCIRCLE)

  _updatePrice() {
    // log.debug( this.currentVariant );
    var selectionData = document.querySelector(".selection-data");
    // CUSTOM FOR BOLD (SHOPCIRCLE)
    var bold_Variant = this.currentVariant;
    // log.debug("BOLD: ", bold_Variant);
    // CUSTOM FOR BOLD (SHOPCIRCLE)

    var priceContainer = document.querySelector(".price-one");
    priceContainer.innerHTML = "";
    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      priceContainer.innerHTML +=
        `<del data-compare="${this.currentVariant.compare_at_price}" data-price="${this.currentVariant.price}">$` +
        (
          Math.round(
            (this.currentVariant.compare_at_price * 0.01 + Number.EPSILON) *
            100,
          ) / 100
        ).toFixed(2) +
        "</del> ";
    }
    if (selectionData.dataset.codeDiscount > 0 && false) {
      var currentPrice =
        this.currentVariant.price - selectionData.dataset.codeDiscount;
      priceContainer.innerHTML +=
        `<del data-compare="${this.currentVariant.price}" data-price="${currentPrice}">$` +
        (
          Math.round(
            (this.currentVariant.price * 0.01 + Number.EPSILON) * 100,
          ) / 100
        ).toFixed(2) +
        "</del> " +
        '<span class="bold_option_price_display">$' +
        (
          Math.round((currentPrice * 0.01 + Number.EPSILON) * 100) / 100
        ).toFixed(2) +
        "</span>";
    } else {
      priceContainer.innerHTML +=
        '<span class="bold_option_price_display">$' +
        (
          Math.round(
            (this.currentVariant.price * 0.01 + Number.EPSILON) * 100,
          ) / 100
        ).toFixed(2) +
        "</span>";
    }

    priceContainer.innerHTML +=
      '<span class="discount-display-wrapper" id="discount-display-product"></span>';

    // CUSTOM FOR BOLD (SHOPCIRCLE)
    setTimeout(() => {
      this._emitBoldVariantChange(bold_Variant);
    }, 500);
    // CUSTOM FOR BOLD (SHOPCIRCLE)

    // Update discount display
    this._updateDiscountDisplay();
  }

  _updateDiscountDisplay() {
    var currentPrice = document
      .querySelector(".price-one .bold_option_price_display")
      .innerHTML.replace("$", "")
      .replace(",", "");
    var accessoriesPrice = 0;
    if (document.querySelector(".price-one del") != null) {
      var noAccessoriesPrice =
        document.querySelector(".price-one del").dataset.price * 0.01;
      var originalPrice =
        document.querySelector(".price-one del").dataset.compare * 0.01;

      accessoriesPrice = currentPrice - noAccessoriesPrice;
      console.log("accessoriesPrice", accessoriesPrice);
      document.querySelector(".price-one del").innerHTML =
        "$" + (originalPrice + accessoriesPrice).toFixed(2);
    }
    var discountWrapper = document.querySelector(
      ".price-one .discount-display-wrapper ",
    );
    var discountWrapper = document.querySelector(
      ".price-one .discount-display-wrapper",
    );
    if (!discountWrapper || !this.currentVariant) return;

    var compareAt = this.currentVariant.compare_at_price || 0;
    var salePrice = this.currentVariant.price || 0;

    if (compareAt > 0 && compareAt > salePrice) {
      var discountAmount = compareAt - salePrice;
      var discountPercent = Math.round((discountAmount * 100.0) / compareAt);
      var discountDollars = Math.round(discountAmount / 100);

      var usePercent = false;
      var useDollar = false;

      if (discountPercent > 40 && discountDollars < 50) {
        usePercent = true;
      } else if (
        discountDollars >= 100 ||
        discountPercent < 10 ||
        discountAmount % 500 === 0
      ) {
        useDollar = true;
      } else {
        usePercent = true;
      }

      var discountText = useDollar
        ? "$" + discountDollars + " Off"
        : discountPercent + "% Off";

      discountWrapper.innerHTML =
        '<span class="discount-display" style="color: #d10300; font-size: 14px;margin-left: 5px;" data-discount-amount="' +
        discountAmount +
        '" data-discount-percent="' +
        discountPercent +
        '">' +
        discountText +
        "</span>";
    } else {
      discountWrapper.innerHTML = "";
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    this._syncHeroSlot(
      document.getElementById("thumbnail-main-slider"),
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`
    );
    this._syncHeroSlot(
      document.getElementById("thumbnail-bottom-slider"),
      `${this.dataset.section}bottom-${this.currentVariant.featured_media.id}`
    );
    // <gallery-tabs> (product-gallery-tabs.js) only swaps the hero slot's *content* here --
    // it doesn't know or care which tab/scroll position is currently on screen. If the
    // shopper had scrolled to another tab, the new photo just changed off-screen and it
    // looks like the swatch click did nothing. Let it know so it can jump back to whichever
    // tab contains position 1 and bring the updated photo into view.
    document.dispatchEvent(new CustomEvent("gallery:hero-updated"));
  }

  // Keeps the very first thumbnail (the fixed "hero" slot, marked with
  // `data-gallery-hero-slot`) showing whichever media is the featured_media of the
  // currently selected variant, WITHOUT moving any other thumbnail around in the list.
  // Only content is swapped between the hero slot and that media's own natural-position
  // <li> (rendered by Liquid, kept hidden via `gallery-hero-duplicate` while it's not the
  // active hero) -- so repeatedly switching size/colour never piles up old photos at the
  // end of the row, it always only ever changes the first thumbnail.
  _syncHeroSlot(list, newMediaId) {
    if (!list) return;
    const heroSlot = list.querySelector("[data-gallery-hero-slot]") || list.firstElementChild;
    if (!heroSlot) return;

    const parent = list.parentElement;
    if (heroSlot.getAttribute("data-media-id") === newMediaId) {
      window.setTimeout(() => {
        if (parent) parent.scroll(0, 0);
      });
      return;
    }

    const naturalNew = Array.from(list.querySelectorAll(`[data-media-id="${newMediaId}"]`)).find(
      (el) => el !== heroSlot
    );
    if (!naturalNew) return;

    const previousHeroId = heroSlot.getAttribute("data-media-id");
    const previousNatural = previousHeroId
      ? Array.from(list.querySelectorAll(`[data-media-id="${previousHeroId}"]`)).find((el) => el !== heroSlot)
      : null;

    heroSlot.innerHTML = naturalNew.innerHTML;
    // The copied <img> keeps loading="lazy" from its natural-position <li>, which is hidden,
    // and some browsers then never load it: the hero stayed blank after a finish switch.
    heroSlot.querySelectorAll("img").forEach((img) => {
      img.setAttribute("loading", "eager");
      img.setAttribute("fetchpriority", "high");
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
    });
    heroSlot.setAttribute("data-media-id", newMediaId);
    heroSlot.setAttribute("data-media-position", "1");
    heroSlot.classList.toggle("product__media-item--full", naturalNew.classList.contains("product__media-item--full"));

    naturalNew.classList.add("gallery-hero-duplicate");
    if (previousNatural) {
      previousNatural.classList.remove("gallery-hero-duplicate");
    }

    window.setTimeout(() => {
      if (parent) parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params.set("variant", this.currentVariant.id);
    // ?open=chat is a one-time action; don't reopen the chat on reload or a copied link
    params.delete("open");
    window.history.replaceState({}, "", `${this.dataset.url}?${params.toString()}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    // log.debug('renderProductInfo');
    // log.debug(this.currentVariant.compare_at_price);
    if (
      this.currentVariant.compare_at_price == null ||
      this.currentVariant.compare_at_price == 0
    ) {
      // log.debug('this.currentVariant.compare_at_price == null || this.currentVariant.compare_at_price == 0');
      jQuery("#product-price > .price").removeClass("price--on-sale");
      // log.debug('remove price on sale');
    } else if (!jQuery(".product-price > .price").hasClass("price--on-sale")) {
      // log.debug('.product-price > .price has class price--on-sale');
      jQuery("#product-price> .price").addClass("price--on-sale");
      log.debug("set price on sale");
    }
    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      // log.debug('compare price > price');
      //var prriice = document.querySelector('.prriice.bold_option_price_display');
      //if(prriice !== null) {
      //  prriice.classList.remove('bold_option_price_display');
      //}
      var priceToUpdate = document.querySelector(
        ".price__sale .price-item.price-item--regular ",
      );
      var priceCompareToUpdate = document.querySelector(
        ".price__compare .price-item.price-item--regular ",
      );
      // log.debug(priceToUpdate);
      if (priceCompareToUpdate) {
        priceCompareToUpdate.dataset.price = (
          Math.round(this.currentVariant.compare_at_price) / 100
        ).toFixed(2);
      }

      priceToUpdate.innerHTML =
        "$" +
        (Math.round(this.currentVariant.compare_at_price) / 100).toFixed(2);
      var priceToUpdate = document.querySelector(
        ".price__last .price-item.price-item--sale ",
      );
      if (!priceToUpdate.classList.contains("bold_option_price_display")) {
        priceToUpdate.classList.add("bold_option_price_display");
        // log.debug('bold price added');
      }
      priceToUpdate.dataset.price = (
        Math.round(this.currentVariant.price) / 100
      ).toFixed(2);
      priceToUpdate.innerHTML =
        "$" + (Math.round(this.currentVariant.price) / 100).toFixed(2);
      // setTimeout(function(){
      //   priceToUpdate.innerHTML = 'A$' + priceToUpdate.dataset.price;

      // }, 1000);
    } else if (
      document.querySelector(".price-item.price-item--regular span") != null
    ) {
      // log.debug('price regular');
      var prriice = document.querySelector(".prriice");
      if (prriice !== null) {
        prriice.classList.add("bold_option_price_display");
      }
      var priceToUpdate = document.querySelector(
        ".price-item.price-item--regular span",
      );
      priceToUpdate.dataset.price = (
        Math.round(this.currentVariant.price) / 100
      ).toFixed(2);
      priceToUpdate.innerHTML =
        "$" + (Math.round(this.currentVariant.price) / 100).toFixed(2);
      // setTimeout(function(){
      //   priceToUpdate.innerHTML = 'A$' + priceToUpdate.dataset.price;

      // }, 1000);
    } else {
      // log.debug('price else');
      var priceToUpdate = document.querySelector(
        ".price-item.price-item--regular",
      );
      priceToUpdate.innerHTML =
        '<span class="prriice" data-price="' +
        (Math.round(this.currentVariant.price) / 100).toFixed(2) +
        '">$' +
        (Math.round(this.currentVariant.price) / 100).toFixed(2) +
        "</span>";
      var priceAddClass = document.querySelector(".prriice");
      priceAddClass.classList.add("bold_option_price_display");
      // log.debug(priceAddClass.textContent);
      setTimeout(function () {
        // log.debug('ee');
        if (priceAddClass.textContent == "$0.00") {
          priceAddClass.textContent = "$" + priceAddClass.dataset.price;
        }
        priceAddClass.innerHTML = "$" + priceAddClass.dataset.price;
      }, 1000);
    }

    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.remove("visibility-hidden");
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut,
    );
    // fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const id = `price-${this.dataset.section}`;
    //     const html = new DOMParser().parseFromString(responseText, 'text/html')
    //     const destination = document.getElementById(id);
    //     const source = html.getElementById(id);

    //     if (source && destination) destination.innerHTML = source.innerHTML;

    //     document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
    //     this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    //   });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    // log.debug('toggleAddButton');

    var addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector(".product-form__submit.bold_clone");
    // check if bold button exist , if not find other add to cart button
    if (addButton === null) {
      addButton = document
        .getElementById(`product-form-${this.dataset.section}`)
        ?.querySelector(".product-form__submit");
    }

    const notifyButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector(".klaviyo-bis-trigger");

    const bottomButton = document.getElementById("cart-bar-add");
    log.debug(bottomButton);
    if (!addButton) return;
    // log.debug(this.currentVariant );
    if (disable) {
      // log.debug('if disable');

      if (this.currentVariant == undefined) {
      } else if (this.currentVariant.available == false) {
        addButton.setAttribute("disabled", true);
        bottomButton.setAttribute("disabled", true);
        if (text) {
          addButton.textContent = text;
          bottomButton.textContent = text;
        } else {
          addButton.textContent = window.variantStrings.soldOut;
          bottomButton.textContent = window.variantStrings.soldOut;
        }
        if (notifyButton != null) {
          notifyButton.classList.remove("hidden");
          notifyButton.classList.add("vis");
        }
      } else if (this.currentVariant.available == true) {
        if (notifyButton != null) {
          notifyButton.classList.add("hidden");
          notifyButton.classList.remove("vis");
        }
        addButton.removeAttribute("disabled");
        addButton.classList.remove("no-selection");
        bottomButton.removeAttribute("disabled");
        if (document.getElementById(`product-form-${this.dataset.section}`).querySelector(".product-form__submit:not(.bold_clone)")) {
          document.getElementById(`product-form-${this.dataset.section}`).querySelector(".product-form__submit:not(.bold_clone)").removeAttribute("disabled");
        }
        addButton.textContent = window.variantStrings.addToCart;
        bottomButton.textContent = window.variantStrings.addToCart;
      }
    } else {
      // log.debug('if disable false');
      if (this.currentVariant == undefined) {
      } else if (this.currentVariant.available == true) {
        if (notifyButton != null) {
          notifyButton.classList.add("hidden");
          notifyButton.classList.remove("vis");
        }
        // log.debug('here 2');
      }

      if (this.currentVariant == undefined) {
      } else if (this.currentVariant.available == false) {
        if (notifyButton != null) {
          notifyButton.classList.remove("hidden");
          notifyButton.classList.add("vis");
        }
        // log.debug('here');
      }
      addButton.removeAttribute("disabled");
      bottomButton.removeAttribute("disabled");
      addButton.classList.remove("no-selection");

      addButton.textContent = window.variantStrings.addToCart;
      bottomButton.textContent = window.variantStrings.addToCart;
      document
        .getElementById(`product-form-${this.dataset.section}`)
        ?.querySelector(".product-form__submit:not(.bold_clone)")
        .removeAttribute("disabled");
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector(".product-form__submit.bold_clone");
    const bottomButton = document.getElementById("cart-bar-add");

    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    bottomButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    if (this.variantData) return this.variantData;
    const local = this.querySelector('[type="application/json"]');
    const shared = document.getElementById(`ProductVariantsJson-${this.dataset.section}`);
    const source = local || shared;
    this.variantData = source ? JSON.parse(source.textContent) : [];
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// ---- Country / language popup (#select-geolocation__popup) ----
// Markup, translated strings (DeskyGeo.i18n) and the store list (DeskyGeo.stores) are in sections/announcement-bar.liquid.
var GEO_CHOICE_COOKIE = "loc_popup";
var GEO_CHOICE_DAYS = 90;
var GEO_COUNTRY_COOKIE = "geo_country";
// EU countries without a store of their own are served by the Germany store (Austria is part of the Germany market).
var GEO_EU_COUNTRIES = ["AT", "IT", "ES", "PT", "IE", "FI", "SE", "DK", "GR", "CZ", "HU", "RO", "BG", "HR", "SK", "SI", "LT", "LV", "EE", "MT", "CY"];
// Other countries without a store: New Zealand is served by the Australia store, the rest by the USA store.
var GEO_NZ_STORE = "australia";
var GEO_DEFAULT_STORE = "usa";
// Stores on their own Shopify shop; every other store is on the EU shop.
var GEO_SHOP_OF_STORE = { australia: "au", usa: "us", canada: "ca" };

var geoPopupEl = document.getElementById("select-geolocation__popup");
var geoDialogEl = geoPopupEl ? geoPopupEl.querySelector('[role="dialog"]') : null;
var geoTitleEl = document.getElementById("geo-detected-title");
var geoShoppingEl = document.getElementById("geo-shopping-line");
var geoNoteEl = document.getElementById("geo-mismatch-note");
var geoCountryEl = document.getElementById("geo-country");
var geoCountryFlagEl = document.getElementById("geo-country-flag");
var geoLanguageEl = document.getElementById("geo-language");
var geoLanguageFieldEl = document.getElementById("geo-language-field");
var geoTriggerEls = ["location-top__banner-content", "location-top__banner-content-footer", "location-top__banner-mobile-menu"]
  .map(function (id) {
    return document.getElementById(id);
  })
  .filter(Boolean);

var geoState = { countryCode: null, countryId: null, langCode: null, opener: null };

function geoAllStores() {
  return window.DeskyGeo && window.DeskyGeo.stores ? window.DeskyGeo.stores : [];
}

function geoEnabledStores() {
  return geoAllStores().filter(function (s) {
    return s.enabled !== false;
  });
}

function geoGetStore(id, includeDisabled) {
  var list = includeDisabled ? geoAllStores() : geoEnabledStores();
  for (var i = 0; i < list.length; i++) {
    if (list[i].id === id) return list[i];
  }
  return null;
}

function geoGetLanguage(store, code) {
  var languages = (store && store.languages) || [];
  for (var i = 0; i < languages.length; i++) {
    if (languages[i].code === code) return languages[i];
  }
  return null;
}

function geoPageLocale() {
  return (window.DeskyGeo && window.DeskyGeo.locale) || document.documentElement.lang || "en";
}

function geoCurrentLangCode() {
  return String(geoPageLocale()).toLowerCase().slice(0, 2);
}

function geoBrowserLangCodes() {
  var list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ""];
  return Array.prototype.map.call(list, function (l) {
    return String(l).toLowerCase().slice(0, 2);
  });
}

// The Liquid `t` filter HTML-escapes strings it interpolates (you're -> you&#39;re), so decode before filling in
function geoFormat(template, values) {
  var text = String(template || "");
  if (text.indexOf("&") !== -1 && window.DOMParser) {
    text = new DOMParser().parseFromString(text, "text/html").documentElement.textContent;
  }
  return text.replace(/%(\w+)%/g, function (match, key) {
    return values[key] != null ? values[key] : match;
  });
}

function geoPathStartsWith(path, prefix) {
  return path === prefix || path.indexOf(prefix + "/") === 0;
}

function geoCurrentStoreId() {
  var host = (window.location.hostname || "").toLowerCase().replace(/^www\./, "");
  var path = (window.location.pathname || "").toLowerCase();
  var shop = typeof Shopify !== "undefined" && Shopify.shop ? String(Shopify.shop) : "";
  if (host === "daesky.com.au") return "australia";
  if (host === "desky.ca") return "canada";
  if (host === "daesky.com") return "usa";
  if (host === "desky.fr") return "france";
  // desky.eu, plus theme previews of the EU shop (myshopify / shopifypreview hosts)
  if (host === "desky.eu" || shop.indexOf("desky-eu") === 0) {
    if (geoPathStartsWith(path, "/nl-nl") || geoPathStartsWith(path, "/en-nl")) return "netherlands";
    if (geoPathStartsWith(path, "/pl-pl") || geoPathStartsWith(path, "/en-pl")) return "poland";
    if (geoPathStartsWith(path, "/nl-be") || geoPathStartsWith(path, "/fr-be") || geoPathStartsWith(path, "/en-be")) {
      return "belgium";
    }
    if (geoPathStartsWith(path, "/fr-lu") || geoPathStartsWith(path, "/de-lu") || geoPathStartsWith(path, "/en-lu")) {
      return "luxembourg";
    }
    return "germany";
  }
  return null;
}

// country: ISO code from browsing_context_suggestions (detected_values.country.handle), e.g. "PL"
function geoStoreIdForCountry(country) {
  if (!country) return null;
  var stores = geoAllStores();
  for (var i = 0; i < stores.length; i++) {
    if (stores[i].country === country) return stores[i].id;
  }
  if (GEO_EU_COUNTRIES.indexOf(country) !== -1) return "germany";
  if (country === "NZ") return GEO_NZ_STORE;
  return GEO_DEFAULT_STORE;
}

// Country name in the page language: the store name when the country has a store, else the browser's own translation.
function geoCountryName(country) {
  if (!country) return "";
  var stores = geoAllStores();
  for (var i = 0; i < stores.length; i++) {
    if (stores[i].country === country) return stores[i].name;
  }
  try {
    return new Intl.DisplayNames([geoPageLocale()], { type: "region" }).of(country) || "";
  } catch (e) {
    return "";
  }
}

// Page language on the current store when asked for it, else the first browser language the store has.
function geoPreferredLangCode(store, preferPage) {
  if (!store || !store.languages || !store.languages.length) return null;
  var page = geoCurrentLangCode();
  var isCurrent = store.id === geoCurrentStoreId();
  if (preferPage && isCurrent && geoGetLanguage(store, page)) return page;
  var browser = geoBrowserLangCodes();
  for (var i = 0; i < browser.length; i++) {
    if (geoGetLanguage(store, browser[i])) return browser[i];
  }
  if (isCurrent && geoGetLanguage(store, page)) return page;
  return store.languages[0].code;
}

function geoNeedsPopup(country) {
  var current = geoCurrentStoreId();
  var rec = geoStoreIdForCountry(country);
  if (!rec || !current || rec !== current) return true;
  // Right store, but on the English version while the store has the visitor's language (e.g. fr-CA on desky.ca)
  var store = geoGetStore(current, true);
  if (!store || store.languages.length < 2 || geoCurrentLangCode() !== "en") return false;
  var preferred = geoPreferredLangCode(store, false);
  return !!preferred && preferred !== "en";
}

function geoShopOf(storeId) {
  return GEO_SHOP_OF_STORE[storeId] || "eu";
}

function geoRenderTriggers() {
  var store = geoGetStore(geoCurrentStoreId(), true);
  if (!store) return;
  geoTriggerEls.forEach(function (el) {
    var img = document.createElement("img");
    img.src = store.flag;
    img.alt = "";
    img.width = 21;
    img.height = 21;
    img.className = "top-icon geo-flag";
    var name = document.createElement("span");
    name.className = "menu-item-title";
    name.textContent = store.name;
    el.innerHTML = "";
    el.appendChild(img);
    el.appendChild(name);
    // Screen readers hear what the button does, not just the store name
    var label = window.DeskyGeo && window.DeskyGeo.i18n && window.DeskyGeo.i18n.triggerLabel;
    if (label) el.setAttribute("aria-label", geoFormat(label, { store: store.name }));
  });
}

// Order: suggested country, then the countries of the current shop, then the rest; alphabetical in the page language.
function geoRenderCountryOptions(recId, currentId) {
  if (!geoCountryEl) return;
  var currentShop = currentId ? geoShopOf(currentId) : null;
  var collator = window.Intl && Intl.Collator ? new Intl.Collator(geoPageLocale()) : null;
  var rank = function (s) {
    if (s.id === recId) return 0;
    return currentShop && geoShopOf(s.id) === currentShop ? 1 : 2;
  };
  var stores = geoEnabledStores()
    .slice()
    .sort(function (a, b) {
      return rank(a) - rank(b) || (collator ? collator.compare(a.name, b.name) : a.name < b.name ? -1 : 1);
    });
  geoCountryEl.innerHTML = "";
  stores.forEach(function (s) {
    var option = document.createElement("option");
    option.value = s.id;
    option.textContent = s.name;
    geoCountryEl.appendChild(option);
  });
  geoCountryEl.value = geoState.countryId;
  geoRenderCountryFlag();
}

function geoRenderCountryFlag() {
  var store = geoGetStore(geoState.countryId);
  if (geoCountryFlagEl && store) geoCountryFlagEl.src = store.flag;
}

function geoRenderLanguageOptions() {
  if (!geoLanguageEl) return;
  var store = geoGetStore(geoState.countryId);
  var languages = (store && store.languages) || [];
  if (!geoGetLanguage(store, geoState.langCode)) {
    geoState.langCode = languages[0] ? languages[0].code : null;
  }
  geoLanguageEl.innerHTML = "";
  languages.forEach(function (l) {
    var option = document.createElement("option");
    option.value = l.code;
    option.lang = l.code;
    option.textContent = l.label;
    geoLanguageEl.appendChild(option);
  });
  geoLanguageEl.value = geoState.langCode;
  if (geoLanguageFieldEl) geoLanguageFieldEl.hidden = languages.length <= 1;
}

function geoPopulate(country, preferPage) {
  var stores = geoEnabledStores();
  if (!stores.length) return;
  var i18n = (window.DeskyGeo && window.DeskyGeo.i18n) || {};
  var currentId = geoCurrentStoreId();
  var currentStore = geoGetStore(currentId, true);
  var recId = geoStoreIdForCountry(country);
  var countryName = geoCountryName(country);

  if (geoTitleEl) {
    var title = countryName ? geoFormat(i18n.titleDetected, { country: countryName }) : i18n.titleChoose;
    if (title) geoTitleEl.textContent = title;
  }
  if (geoShoppingEl) {
    geoShoppingEl.textContent = currentStore ? geoFormat(i18n.shoppingIn, { store: currentStore.name }) : "";
    geoShoppingEl.hidden = !currentStore || !i18n.shoppingIn;
  }
  if (geoNoteEl) {
    var showNote = !!(recId && currentStore && countryName && recId !== currentId && geoGetStore(recId) && i18n.shippingNote);
    geoNoteEl.textContent = showNote ? geoFormat(i18n.shippingNote, { store: currentStore.name, country: countryName }) : "";
    geoNoteEl.hidden = !showNote;
  }

  geoState.countryId = geoGetStore(recId) ? recId : geoGetStore(currentId) ? currentId : stores[0].id;
  geoState.langCode = geoPreferredLangCode(geoGetStore(geoState.countryId), preferPage);
  geoRenderCountryOptions(recId, currentId);
  geoRenderLanguageOptions();
}

function geoIsOpen() {
  return !!geoPopupEl && !geoPopupEl.classList.contains("hide");
}

function geoFocusable() {
  if (!geoDialogEl) return [];
  var items = geoDialogEl.querySelectorAll('button, select, a[href], input, [tabindex]:not([tabindex="-1"])');
  return Array.prototype.filter.call(items, function (el) {
    return !el.disabled && el.offsetParent !== null;
  });
}

function geoOnKeydown(e) {
  if (e.key === "Escape" || e.key === "Esc") {
    e.preventDefault();
    geoStay();
    return;
  }
  if (e.key !== "Tab") return;
  var items = geoFocusable();
  if (!items.length) {
    e.preventDefault();
    return;
  }
  var first = items[0];
  var last = items[items.length - 1];
  var active = document.activeElement;
  if (!geoDialogEl.contains(active)) {
    e.preventDefault();
    (e.shiftKey ? last : first).focus();
  } else if (e.shiftKey && (active === first || active === geoDialogEl)) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && active === last) {
    e.preventDefault();
    first.focus();
  }
}

// Keeps focus in the dialog when a script (chat, signup form) moves it out
function geoOnFocusIn(e) {
  if (geoDialogEl && !geoDialogEl.contains(e.target)) geoDialogEl.focus();
}

// Everything outside the dialog is inert while it is open, also what scripts (Klaviyo) add to <body> meanwhile
var geoInertEls = [];
var geoInertObserver = null;

function geoMakeInert(el) {
  if (el === geoPopupEl || el.nodeType !== 1 || el.inert || /^(SCRIPT|STYLE|LINK|NOSCRIPT|TEMPLATE)$/.test(el.tagName)) {
    return;
  }
  el.inert = true;
  geoInertEls.push(el);
}

function geoSetPageInert(on) {
  if (on) {
    Array.prototype.forEach.call(document.body.children, geoMakeInert);
    if (window.MutationObserver) {
      geoInertObserver = new MutationObserver(function (records) {
        records.forEach(function (r) {
          Array.prototype.forEach.call(r.addedNodes, geoMakeInert);
        });
      });
      geoInertObserver.observe(document.body, { childList: true });
    }
  } else {
    if (geoInertObserver) geoInertObserver.disconnect();
    geoInertObserver = null;
    geoInertEls.forEach(function (el) {
      el.inert = false;
    });
    geoInertEls = [];
  }
}

// opener: element that gets focus back on close; preferPage: preselect the page language on the current store
function geoOpen(opener, preferPage) {
  if (!geoPopupEl || !geoDialogEl || geoIsOpen()) return;
  geoState.opener = opener || document.activeElement;
  geoPopulate(geoState.countryCode || getCookie(GEO_COUNTRY_COOKIE) || null, preferPage);
  // Lock the page under the popup; pad by the scrollbar width so the page doesn't jump sideways
  var scrollbar = window.innerWidth - document.documentElement.clientWidth;
  if (scrollbar > 0) document.body.style.paddingRight = scrollbar + "px";
  geoPopupEl.classList.remove("hide");
  document.documentElement.classList.add("geo-open");
  document.body.classList.add("geo-open");
  geoSetPageInert(true);
  document.addEventListener("keydown", geoOnKeydown);
  document.addEventListener("focusin", geoOnFocusIn);
  geoDialogEl.focus();
}

function geoClose() {
  if (!geoIsOpen()) return;
  geoPopupEl.classList.add("hide");
  document.documentElement.classList.remove("geo-open");
  document.body.classList.remove("geo-open");
  document.body.style.paddingRight = "";
  geoSetPageInert(false);
  document.removeEventListener("keydown", geoOnKeydown);
  document.removeEventListener("focusin", geoOnFocusIn);
  var opener = geoState.opener;
  geoState.opener = null;
  // Opened from the mobile menu: geoInit closed that menu, so focus its toggle (the menu's own close animation
  // keeps the trigger focusable for a moment, then hides it and focus would fall to <body>)
  if (opener && opener.closest && opener.closest("header-drawer")) {
    opener = document.querySelector("header-drawer summary") || opener;
  }
  if (opener && opener !== document.body && document.contains(opener) && typeof opener.focus === "function") {
    opener.focus();
  }
}

function geoRememberChoice() {
  setCookie(GEO_CHOICE_COOKIE, "chosen", GEO_CHOICE_DAYS);
}

function geoStay() {
  geoRememberChoice();
  geoClose();
}

// Same page on the other store. The hreflang tags in <head> carry the translated handles
// (/pl-pl/products/biurko-... -> daesky.com/products/dual-...); the hreflang-logic URL is the fallback.
function geoPageUrl(store, lang) {
  var link = document.querySelector('link[rel="alternate"][hreflang="' + lang.code + "-" + store.country + '"]');
  return (link && link.href) || lang.url;
}

function geoSwitch() {
  var store = geoGetStore(geoState.countryId);
  if (!store) return;
  var lang = geoGetLanguage(store, geoState.langCode) || store.languages[0];
  geoRememberChoice();
  if (!lang || !lang.url || (store.id === geoCurrentStoreId() && lang.code === geoCurrentLangCode())) {
    geoClose();
    return;
  }
  var target;
  try {
    target = new URL(geoPageUrl(store, lang), window.location.href);
  } catch (e) {
    geoClose();
    return;
  }
  // The cookie is per domain: tell the other store the visitor already chose
  if (target.hostname !== window.location.hostname) target.searchParams.set("geo", "chosen");
  window.location.href = target.toString();
}

// ?geo=chosen comes from geoSwitch() on another store's domain
function geoReadChoiceParam() {
  if (!window.URLSearchParams) return;
  var params = new URLSearchParams(window.location.search);
  if (params.get("geo") !== "chosen") return;
  geoRememberChoice();
  params.delete("geo");
  var query = params.toString();
  if (window.history && history.replaceState) {
    history.replaceState(history.state, "", window.location.pathname + (query ? "?" + query : "") + window.location.hash);
  }
}

function geoDetectCountry(callback) {
  var cached = getCookie(GEO_COUNTRY_COOKIE);
  if (cached) {
    geoState.countryCode = cached;
    callback(cached);
    return;
  }
  fetch("/browsing_context_suggestions.json", { credentials: "same-origin" })
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (data) {
      var country = data && data.detected_values && data.detected_values.country;
      var code = country && country.handle ? String(country.handle).toUpperCase() : "";
      if (!code) return;
      setCookie(GEO_COUNTRY_COOKIE, code, 30);
      geoState.countryCode = code;
      callback(code);
    })
    .catch(function (err) {
      log.debug(err);
    });
}

// One overlay at a time: wait until the Shopify cookie banner is answered (or not needed)
function geoWhenConsentAnswered(callback) {
  var done = false;
  var run = function () {
    if (done) return;
    done = true;
    callback();
  };
  var check = function () {
    try {
      if (!window.Shopify.customerPrivacy.shouldShowBanner()) {
        run();
        return;
      }
    } catch (e) {
      run();
      return;
    }
    // The banner can be missing although it "should show" (theme previews, ad blockers): nobody can answer it then
    setTimeout(function () {
      var banner = document.getElementById("shopify-pc__banner");
      var visible = !!banner && banner.getClientRects().length > 0 && getComputedStyle(banner).visibility !== "hidden";
      if (!visible) run();
    }, 3000);
  };
  document.addEventListener("visitorConsentCollected", run, { once: true });
  if (window.Shopify && window.Shopify.customerPrivacy) {
    check();
  } else if (window.Shopify && typeof Shopify.loadFeatures === "function") {
    Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      if (err) run();
      else check();
    });
  } else {
    run();
  }
}

function geoInit() {
  if (!geoPopupEl || !geoDialogEl) return;
  // Under <body>, so no header stacking context paints over the popup
  if (geoPopupEl.parentNode !== document.body) document.body.appendChild(geoPopupEl);
  geoRenderTriggers();

  geoTriggerEls.forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      if (el.id === "location-top__banner-mobile-menu") {
        var summary = document.querySelector("header-drawer summary");
        if (summary) summary.click();
      }
      geoOpen(el, true);
    });
  });
  var background = document.getElementById("background-geolocation__popup");
  var closeButton = document.getElementById("geolocation-popup__close-button");
  var switchButton = document.getElementById("geo-switch-btn");
  var stayButton = document.getElementById("geo-stay-btn");
  if (background) background.addEventListener("click", geoStay);
  if (closeButton) closeButton.addEventListener("click", geoStay);
  if (stayButton) stayButton.addEventListener("click", geoStay);
  if (switchButton) switchButton.addEventListener("click", geoSwitch);
  if (geoCountryEl) {
    geoCountryEl.addEventListener("change", function () {
      geoState.countryId = geoCountryEl.value;
      geoState.langCode = geoPreferredLangCode(geoGetStore(geoState.countryId), true);
      geoRenderCountryFlag();
      geoRenderLanguageOptions();
    });
  }
  if (geoLanguageEl) {
    geoLanguageEl.addEventListener("change", function () {
      geoState.langCode = geoLanguageEl.value;
    });
  }

  if (window.location.href.indexOf("collaboration-request") >= 0) return;
  geoReadChoiceParam();
  if (getCookie(GEO_CHOICE_COOKIE) === "chosen") return;
  geoDetectCountry(function (country) {
    if (!geoNeedsPopup(country)) return;
    geoWhenConsentAnswered(function () {
      if (getCookie(GEO_CHOICE_COOKIE) !== "chosen") geoOpen(null, false);
    });
  });
}
geoInit();

function closeTopBarDiscount() {
  $(".very-top-bar").on("click", ".close-button", function () {
    setCookie("topBarDiscount", "closed", 1);
    $(".very-top-bar").removeClass("active");
  });
}
closeTopBarDiscount();

function closeAfterHeaderBar() {
  if (!getCookie("afterHeaderBar")) {
    $(".nav-usps").addClass("active");
  } else {
  }
  $(".nav-usps").on("click", ".close-button", function () {
    setCookie("afterHeaderBar", "closed", 1);
    $(".nav-usps").removeClass("active");
  });
}
closeAfterHeaderBar();
// var quantityInputs = document.querySelectorAll('.main-cart__slider .quantity__input');

// quantityInputs.forEach(element => {
//   log.debug(element);
//   element.addEventListener('keypress', logKey);
// });
// document.addEventListener('keypress', logKey);
// function logKey(e) {
//   log.debug(e.target.classList.contains('quantity__input'));
//   log.debug(e.target.closest('.btns-slider'));
//   if(e.target.closest('.btns-slider') && e.target.classList.contains('quantity__input') && (e.code == 'Enter' || e.code == 'NumpadEnter')){
//     e.preventDefault();
//   }
// }

function openDeskyLiveChat(event) {
  if (event) event.preventDefault();

  function tryOpen() {
    if (typeof window.zE === 'function') {
      try {
        window.zE('messenger', 'open');
        return true;
      } catch (_) {}
      try {
        window.zE('webWidget', 'open');
        return true;
      } catch (_) {}
    }

    var zendeskLauncher = document.getElementById('desky-zendesk-custom-launcher');
    if (zendeskLauncher) {
      zendeskLauncher.click();
      return true;
    }

    if (typeof LiveChatWidget !== 'undefined' && LiveChatWidget.call) {
      LiveChatWidget.call('maximize');
      return true;
    }

    return false;
  }

  if (tryOpen()) return;

  var attempts = 0;
  var iv = setInterval(function () {
    if (tryOpen() || ++attempts > 40) clearInterval(iv);
  }, 100);
}

document.querySelectorAll('#footer-open-chat, #top-menu-chat, .top-menu-chat a').forEach(function (el) {
  el.addEventListener('click', openDeskyLiveChat);
});

waitForElement('#reamaze-widget', function (liveChat) {
  var footerChat = document.getElementById('footer-open-chat');
  if (!footerChat || typeof window.zE === 'function' || document.getElementById('desky-zendesk-custom-launcher')) {
    return;
  }
  footerChat.addEventListener('click', function () {
    liveChat.click();
  });
});

var liveChat = document.querySelector('#reamaze-widget');
var footerrLiveChat = document.querySelector('#footer-open-chat');
var topLiveChat = document.getElementById('top-menu-chat');
var footerLiveChat = document.getElementById('footer-open-chat');
let openHide = false;
function chatWithUsLive(event) {
  openDeskyLiveChat(event);
}

let dropdownDesc = {
  // desk tops - which sizes are available in which colours
  // which legs colours are available
  // find all options with given desk top colour
  // find all oos options with given desk colour
  // if all variants with given desk colour are oos set desk colour to oos
  // if all variants with given desk size are not available set desk size to oos
  // if all variants with given leg colour are not available set leg to oos
  // when desk colour in given size is not available, then size should be set to oos if desk colour is selected  or if size is selected then colours with this size should be oos
  selectedOptions: {
    option1: "",
    option2: "",
    option3: "",
  },
  closeDropdown: function (target) {
    $(target)
      .closest(".dropdown-option")
      .find(".dropdown-items")
      .removeClass("active");
  },
  findOosColours: function () {
    var _this = this;
    var allColours = [...new Set(prodVariants.map((item) => item.option1))];
    var availableColours = [];

    allColours.forEach((item) => {
      var inStockVariants = prodVariants.filter((obj) => {
        return obj.option1 === item && obj.available == true;
      });
      if (inStockVariants.length > 0) {
        availableColours.push(item);
      }
    });

    var notAvailableColours = allColours.filter(
      (x) => !availableColours.includes(x),
    );
    _this.setOos(
      notAvailableColours,
      '.dropdown-option[data-option="1"] .dropdown-item',
    );
  },
  setOos: function (props, parent) {
    props.forEach((prop) => {
      $(parent).each(function () {
        if ($(this).text() == prop) {
          $(this).addClass("oos");
        }
      });
    });
  },
  findOos: function (option1, option2, option3) {
    var oos = {
      option1: [],
      option2: [],
      option3: [],
    };
    var inStock = {
      option1: [],
      option2: [],
      option3: [],
    };
    if (option1 != "") {
      var oosVariants = prodVariants.filter((obj) => {
        return obj.option1 === option1 && obj.available == false;
      });
      var inStockVariants = prodVariants.filter((obj) => {
        return obj.option1 === option1 && obj.available == true;
      });
    }

    oosVariants.forEach((result) => {
      oos.option2.push(result.option2);
    });
    inStockVariants.forEach((result) => {
      inStock.option2.push(result.option2);
    });
    oos.option2 = [...new Set(oos.option2)];
    inStock.option2 = [...new Set(inStock.option2)];
    oos.option2 = oos.option2.filter((x) => !inStock.option2.includes(x));

    return oos;
  },
  findOosLegs: function (option1, option2) {
    var oos = {
      option1: [],
      option2: [],
      option3: [],
    };
    var inStock = {
      option1: [],
      option2: [],
      option3: [],
    };

    var oosVariants = prodVariants.filter((obj) => {
      return (
        obj.option1 === option1 &&
        obj.option2 === option2 &&
        obj.available == false
      );
    });

    var inStockVariants = prodVariants.filter((obj) => {
      return (
        obj.option1 === option1 &&
        obj.option2 === option2 &&
        obj.available == true
      );
    });

    oosVariants.forEach((result) => {
      oos.option3.push(result.option3);
    });
    inStockVariants.forEach((result) => {
      inStock.option3.push(result.option3);
    });
    oos.option3 = [...new Set(oos.option3)];

    return oos;
  },
  setPreorder: function () {
    // if preorder value selected, add info about preorder to selected item
    log.debug("setPreorder");

    // Guard: skip preorder logic if variantsOnPreorder is not defined (e.g. on main-product.liquid templates)
    if (typeof variantsOnPreorder === "undefined" || typeof preorderOrder === "undefined") {
      return;
    }

    var selectedItems = [];

    // get current selects
    $(".dropdown-item.selected").each(function () {
      log.debug(
        $(this).closest(".dropdown-option").data("option") - 1,
        $(this).data("index"),
        $(this).data("preorder-message")
          ? $(this).data("preorder-message")
          : "",
      );
      selectedItems.push({
        optionNr: $(this).closest(".dropdown-option").data("option") - 1,
        indexNr: $(this).data("index"),
        preorderMessage: $(this).data("preorder-message")
          ? $(this).data("preorder-message")
          : "",
      });
    });

    //get current variant
    let url = new URL(window.location.href); // Use window.location.href to get the current URL
    let params = new URLSearchParams(url.search);
    let currentVariant = params.get("variant");
    log.debug(variantsOnPreorder);
    log.debug(selectedItems);

    function sortMessagesByPreorder(messages, preorderMessages) {
      return messages.sort((a, b) => {
        return (
          preorderMessages.indexOf(a.preorderMessage) -
          preorderMessages.indexOf(b.preorderMessage)
        );
      });
    }

    // array.find(item => item.optionNr === 1);
    var preorderText = "";
    var option0Message = selectedItems.find((item) => item.optionNr === 0)
      ? selectedItems.find((item) => item.optionNr === 0).preorderMessage
      : "";
    var currentVariantPreorderMessage = variantsOnPreorder.find(
      (item) => item.variant_id === currentVariant,
    )
      ? variantsOnPreorder.find((item) => item.variant_id === currentVariant)
        .preorderMessage
      : "";
    // log.debug(option0Message, currentVariantPreorderMessage);
    var preorderText = "";

    // is current variant on preorder
    if (currentVariantPreorderMessage.length > 0) {
      preorderText = currentVariantPreorderMessage;
      // is some options on preorder
    } else if (selectedItems.some((item) => item.preorderMessage.length > 0)) {
      //
      if (
        variantsOnPreorder.some(
          (item) => item.preorderMessage == option0Message,
        )
      ) {
        messages = selectedItems.filter((item) => item.optionNr !== 0);
        messages = messages.filter((item) => item.preorderMessage != "");
        // log.debug(preorderOrder);
        // log.debug(messages);
        // log.debug(sortMessagesByPreorder(messages,preorderOrder));
      } else {
        messages = selectedItems.filter((item) => item.preorderMessage != "");
        // log.debug(sortMessagesByPreorder(messages,preorderOrder));
      }
      messages = sortMessagesByPreorder(messages, preorderOrder);
      preorderText = messages.length > 0 ? messages[0].preorderMessage : "";
    }

    log.debug(preorderText);
    if (preorderText.length > 0) {
      // update line item
      if ($("#preorderText").length > 0) {
        $("#preorderText").val(preorderText);
      } else {
        $('[data-type="add-to-cart-form"]').append(
          `<input type="hidden" id="preorderText" name="properties[Preorder]" value="${preorderText}">`,
        );
      }

      //update cart info
      if ($("#_preorder").length > 0) {
        $("#_preorder").val(preorderText);
      } else {
        $("#carto").append(
          `<input type="hidden" id="_preorder" name="attributes[_preorder]" value="true">`,
        );
      }

      // hide timer
      $(".product-timer:not(.cart-timer)").each(function () {
        $(this).hide();
      });
    } else {
      // remove line item info about preorder
      $('[data-type="add-to-cart-form"] #preorderText').detach();
      // remove cart info about preorder
      $("#carto #__preorder").detach();

      // show timer
      $(".product-timer:not(.cart-timer)").show();
    }
  },
  hideSelectInputs: function () {
    $(".product-select-option-0").parent().parent().hide();
    $(".product-select-option-1").parent().parent().hide();
    $(".product-select-option-2").parent().parent().hide();
    $('[name="properties[Leg Color]"]').closest(".bold_option_dropdown").hide();
    $('[name="properties[Frame Color]"]').parent().hide();
    $('[name="properties[Desk Color]"]').parent().hide();
  },
  preSelects: function () {
    let _this = this;
    let href = window.location.href;
    if (href.includes("?variant") && window.selectedVariant != null) {
      window.selectedVariant.options.forEach((element, index) => {
        $(
          `.dropdown-option[data-option="${parseInt(index) + 1
          }"] .dropdown-items .dropdown-item`,
        ).each(function (index) {
          //log.debug(element, $(this).text().trim().replace(/"/g,"&#34;"));
          if ($(this).text().trim().replace(/"/g, "&#34;") == element) {
            _this.selectVariant(this);
          }
        });
      });
    } else {
      log.debug(window.firstVariant);
      if (window.firstVariant != null) {
        window.firstVariant.options.forEach((element, index) => {
          // log.debug(element);
          $(
            `.dropdown-option[data-option="${parseInt(index) + 1
            }"] .dropdown-items .dropdown-item`,
          ).each(function (index) {
            if ($(this).text() == element) {
              _this.selectVariant(this);
            }
          });
          $(
            `.swatches-wrapper[data-option="${parseInt(index) + 1}"] .swatch`,
          ).each(function () {
            if ($(this).find(".swatch-image").attr("title") == element) {
              $(this).addClass("active");
            }
          });
        });
      }
    }
  },
  selectVariant: function (target) {
    var _this = this;
    log.debug("t", target);
    $(target).parent().find(".dropdown-item").removeClass("selected");
    $(target).addClass("selected");
    // log.debug($(target));
    // log.debug($(target).closest('.dropdown-option').data('option'));

    var optionSetSelect = document.getElementsByClassName(
      `product-select-option-${parseInt($(target).closest(".dropdown-option").data("option")) - 1
      }`,
    );

    if (
      document.getElementsByName("properties[Leg Color]").length > 0 &&
      $(target).closest(".dropdown-option").data("type") == "Leg Color"
    ) {
      optionSetSelect = document.getElementsByName("properties[Leg Color]");
      // log.debug('bold');
    }
    if (document.getElementsByName("properties[Frame Color]").length > 0) {
      optionSetSelect = document.getElementsByName("properties[Frame Color]");
    }
    if (document.getElementsByName("properties[Desk Color]").length > 0) {
      optionSetSelect = document.getElementsByName("properties[Desk Color]");
    }
    var ind = 0;

    if (optionSetSelect[0][0].innerHTML.includes("Pick")) {
      ind = $(target).data("index") + 1;
      // log.debug('ind includes pick');
    } else {
      ind = $(target).data("index");
    }

    optionSetSelect[0].selectedIndex = parseInt(ind);

    //var ev = document.createEvent("HTMLEvents");
    //ev.initEvent("change", true);
    // Create and dispatch the event
    let ev = new Event("change", {
      bubbles: true,
      cancelable: true,
    });

    //element.dispatchEvent(event);
    optionSetSelect[0].dispatchEvent(ev);
    var selectedText = "";
    var preorderText = "";
    if (
      $(target).data("preorder") != undefined &&
      $(target).data("preorder").length > 0
    ) {
      selectedText = $(target).data("preorder");
      preorderText = $(target).data("preorder-message");
      log.debug($(target).closest(".dropdown-option").data("option") - 1);
      log.debug(preorderText);
    } else {
      var selectedText = $(target).text();
    }

    _this.setPreorder();
    $(target)
      .closest(".dropdown-option")
      .find(".dropdown-item-selected")
      .html(
        selectedText +
        `<svg width="11" height="11" aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 9">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
  </path></svg>`,
      );

    if ($(target).closest(".dropdown-option").data("option") == "1") {
      _this.selectedOptions.option1 = $(target).text();
      if ($("body").hasClass("template-product.almost-perfect")) {
        $('.dropdown-option[data-option="2"] .dropdown-item').removeClass(
          "oos",
        );
        _this.setOos(
          _this.findOos($(target).text(), "", "").option2,
          '.dropdown-option[data-option="2"] .dropdown-item',
        );
      }

      $(`.product-select-option-0 option[value='${$(target).text()}']`).prop(
        "selected",
        true,
      );
    }
    if ($(target).closest(".dropdown-option").data("option") == "2") {
      _this.selectedOptions.option2 = $(target).text();
      if ($("body").hasClass("template-product.almost-perfect")) {
        $('.dropdown-option[data-option="3"] .dropdown-item').removeClass(
          "oos",
        );
        _this.setOos(
          _this.findOosLegs(
            _this.selectedOptions.option1,
            _this.selectedOptions.option2,
          ).option3,
          '.dropdown-option[data-option="3"] .dropdown-item',
        );
      }
      $(`.product-select-option-1 option[value='${$(target).text()}']`).prop(
        "selected",
        true,
      );
    }
    if ($(target).closest(".dropdown-option").data("option") == "3") {
      _this.selectedOptions.option3 = $(target).text();
      $(`.product-select-option-2 option[value='${$(target).text()}']`).prop(
        "selected",
        true,
      );
    }

    _this.closeDropdown(target);
  },
  events: function () {
    var _this = this;
    //_this.hideSelectInputs();
    function waitForElement(selector, callback, timeout = 5000) {
      const interval = 100; // Check every 100ms
      let elapsedTime = 0;

      const intervalId = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
          callback(element);
        } else {
          elapsedTime += interval;
          if (elapsedTime >= timeout) {
            clearInterval(intervalId);
          }
        }
      }, interval); // Check every 100ms

      const timeoutId = setTimeout(() => {
        clearInterval(intervalId);
      }, timeout);
    }

    // Usage
    _this.preSelects();
    waitForElement(".bold_option_title", (element) => {
      _this.hideSelectInputs();
      _this.preSelects();
    });

    if ($("body").hasClass("template-product.almost-perfect")) {
      _this.findOosColours();
    }

    function toggleDropdown(el) {
      var $dropdownItems = $(el).closest(".dropdown-option").find(".dropdown-items");
      if ($dropdownItems.hasClass("active")) {
        $dropdownItems.removeClass("active");
        $(el).attr("aria-expanded", "false");
      } else {
        $dropdownItems.addClass("active");
        $(el).attr("aria-expanded", "true");
        document.querySelectorAll("span.selection-required-message").forEach(function (item) {
          item.parentElement.removeChild(item);
        });
        var firstItem = $dropdownItems.find(".dropdown-item").first();
        if (firstItem.length) firstItem.focus();
      }
    }

    $(document).on("click", ".dropdown-item-selected", function (e) {
      e.preventDefault();
      toggleDropdown(e.currentTarget);
    });
    $(document).on("keydown", ".dropdown-item-selected", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleDropdown(e.currentTarget);
      }
      if (e.key === "Escape") {
        $(e.currentTarget).closest(".dropdown-option").find(".dropdown-items").removeClass("active");
        $(e.currentTarget).attr("aria-expanded", "false");
      }
    });

    $(document).on("click", ".dropdown-item", function (e) {
      _this.selectVariant(e.currentTarget);
      var $selected = $(e.currentTarget).closest(".dropdown-option").find(".dropdown-item-selected");
      $(e.currentTarget).closest(".dropdown-items").removeClass("active");
      $selected.attr("aria-expanded", "false");
    });
    $(document).on("keydown", ".dropdown-item", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        _this.selectVariant(e.currentTarget);
        var $selected = $(e.currentTarget).closest(".dropdown-option").find(".dropdown-item-selected");
        $(e.currentTarget).closest(".dropdown-items").removeClass("active");
        $selected.attr("aria-expanded", "false");
        $selected.focus();
      }
      if (e.key === "Escape") {
        var $selected = $(e.currentTarget).closest(".dropdown-option").find(".dropdown-item-selected");
        $(e.currentTarget).closest(".dropdown-items").removeClass("active");
        $selected.attr("aria-expanded", "false");
        $selected.focus();
      }
      if (e.key === "ArrowDown") {
        e.preventDefault();
        var $next = $(e.currentTarget).next(".dropdown-item");
        if ($next.length) $next.focus();
      }
      if (e.key === "ArrowUp") {
        e.preventDefault();
        var $prev = $(e.currentTarget).prev(".dropdown-item");
        if ($prev.length) $prev.focus();
      }
    });

    // $(document).mouseup(function(e)
    // {
    //     var container = $(".dropdown-item-selected");

    //     // if the target of the click isn't the container nor a descendant of the container
    //     if (!container.is(e.target) && container.has(e.target).length === 0)
    //     {
    //       $('.dropdown-items').removeClass('active');
    //     }
    // });
    // $(window).on('scroll', (e) => {
    //   log.debug($(window).scrollTop());

    //     $('.dropdown-items').removeClass('active');

    // });
  },
  init: function () {
    this.events();
  },
};
if (typeof prodVariants !== "undefined" && prodVariants !== null) {
  setTimeout(dropdownDesc.init(), 500);
}
function toTitleCase(str) {
  return str
    .replace(/-/g, " ") // Replace dashes with spaces
    .replace(/\b\w/g, function (match) {
      return match.toUpperCase(); // Capitalize each word
    });
}

let productSwatches = {
  selectSwatch: function (target) {
    $(
      `.product-select-option-${$(target).data("option") - 1} option[value='${$(
        target,
      )
        .find(".swatch-name")
        .text()}']`,
    ).prop("selected", true);

    // var ev = document.createEvent("HTMLEvents");
    // ev.initEvent("change", true);
    let ev = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    document
      .querySelector(`.product-select-option-${$(target).data("option") - 1}`)
      .dispatchEvent(ev);
    $(target).parent().find(".swatch").removeClass("active");
    $(target).addClass("active");
    $(target)
      .closest(".swatches")
      .find(".title strong")
      .text($(target).find(".swatch-image").attr("title"));
  },
  setPreorder: function () {
    // if preorder value selected, add info about preorder to selected item
    log.debug("setPreorder");

    // Guard: skip preorder logic if variantsOnPreorder is not defined (e.g. on main-product.liquid templates)
    if (typeof variantsOnPreorder === "undefined" || typeof preorderOrder === "undefined") {
      return;
    }

    var selectedItems = [];

    // get current selects
    $(".dropdown-item.selected").each(function () {
      log.debug(
        $(this).closest(".dropdown-option").data("option") - 1,
        $(this).data("index"),
        $(this).data("preorder-message")
          ? $(this).data("preorder-message")
          : "",
      );
      selectedItems.push({
        optionNr: $(this).closest(".dropdown-option").data("option") - 1,
        indexNr: $(this).data("index"),
        preorderMessage: $(this).data("preorder-message")
          ? $(this).data("preorder-message")
          : "",
      });
    });

    //get current variant
    let url = new URL(window.location.href); // Use window.location.href to get the current URL
    let params = new URLSearchParams(url.search);
    let currentVariant = params.get("variant");
    log.debug(variantsOnPreorder);
    log.debug(selectedItems);

    function sortMessagesByPreorder(messages, preorderMessages) {
      return messages.sort((a, b) => {
        return (
          preorderMessages.indexOf(a.preorderMessage) -
          preorderMessages.indexOf(b.preorderMessage)
        );
      });
    }

    // array.find(item => item.optionNr === 1);
    var preorderText = "";
    var option0Message = selectedItems.find((item) => item.optionNr === 0)
      ? selectedItems.find((item) => item.optionNr === 0).preorderMessage
      : "";
    var currentVariantPreorderMessage = variantsOnPreorder.find(
      (item) => item.variant_id === currentVariant,
    )
      ? variantsOnPreorder.find((item) => item.variant_id === currentVariant)
        .preorderMessage
      : "";
    // log.debug(option0Message, currentVariantPreorderMessage);
    var preorderText = "";

    // is current variant on preorder
    if (currentVariantPreorderMessage.length > 0) {
      preorderText = currentVariantPreorderMessage;
      // is some options on preorder
    } else if (selectedItems.some((item) => item.preorderMessage.length > 0)) {
      //
      if (
        variantsOnPreorder.some(
          (item) => item.preorderMessage == option0Message,
        )
      ) {
        messages = selectedItems.filter((item) => item.optionNr !== 0);
        messages = messages.filter((item) => item.preorderMessage != "");
        // log.debug(preorderOrder);
        // log.debug(messages);
        // log.debug(sortMessagesByPreorder(messages,preorderOrder));
      } else {
        messages = selectedItems.filter((item) => item.preorderMessage != "");
        // log.debug(sortMessagesByPreorder(messages,preorderOrder));
      }
      messages = sortMessagesByPreorder(messages, preorderOrder);
      preorderText = messages.length > 0 ? messages[0].preorderMessage : "";
    }

    log.debug(preorderText);
    if (preorderText.length > 0) {
      // update line item
      if ($("#preorderText").length > 0) {
        $("#preorderText").val(preorderText);
      } else {
        $('[data-type="add-to-cart-form"]').append(
          `<input type="hidden" id="preorderText" name="properties[Preorder]" value="${preorderText}">`,
        );
      }

      //update cart info
      if ($("#_preorder").length > 0) {
        $("#_preorder").val(preorderText);
      } else {
        $("#carto").append(
          `<input type="hidden" id="_preorder" name="attributes[_preorder]" value="true">`,
        );
      }

      // hide timer
      $(".product-timer:not(.cart-timer)").each(function () {
        $(this).hide();
      });
    } else {
      // remove line item info about preorder
      $('[data-type="add-to-cart-form"] #preorderText').detach();
      // remove cart info about preorder
      $("#carto #__preorder").detach();

      // show timer
      $(".product-timer:not(.cart-timer)").show();
    }
  },
  selectDeskSwatch: function (target) {
    var self = this;

    // select 'target' variant on dropdown field
    $(
      `.product-select-option-${$(target).data("option") - 1} option[value='${$(
        target,
      )
        .find(".swatch-image")
        .attr("title")}']`,
    ).prop("selected", true);
    var optionSetSelect = document.getElementsByClassName(
      `product-select-option-${$(target).data("option") - 1}`,
    );

    if (
      document.getElementsByName("properties[Leg Color]").length > 0 &&
      $(target).data("type") == "leg-color"
    ) {
      var optionSetSelect = document.getElementsByName("properties[Leg Color]");
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Frame Color]").length > 0 &&
      $(target).data("type") == "frame-color"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Frame Color]",
      );
      // log.debug('bold');
    }

    if (
      document.getElementsByName("properties[Desk Colour]").length > 0 &&
      $(target).data("type") == "desk-colour"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Desk Colour]",
      );
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Desktop Colour]").length > 0 &&
      $(target).data("type") == "desktop-colour"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Desktop Colour]",
      );
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Colour]").length > 0 &&
      $(target).data("type") == "colour"
    ) {
      var optionSetSelect = document.getElementsByName("properties[Colour]");
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Desk Color]").length > 0 &&
      $(target).data("type") == "desk-color"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Desk Color]",
      );
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Desktop Color]").length > 0 &&
      $(target).data("type") == "desktop-color"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Desktop Color]",
      );
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Color]").length > 0 &&
      $(target).data("type") == "color"
    ) {
      var optionSetSelect = document.getElementsByName("properties[Color]");
      // log.debug('bold');
    }
    log.debug(optionSetSelect);
    var ind = 0;

    if (optionSetSelect[0][0].innerHTML.includes("Pick")) {
      ind = $(target).data("index") + 1;
      // log.debug('ind includes pick');
    } else {
      ind = $(target).data("index");
    }

    optionSetSelect[0].selectedIndex = parseInt(ind);

    // var ev = document.createEvent("HTMLEvents");
    // ev.initEvent("change", true);
    let ev = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    optionSetSelect[0].dispatchEvent(ev);
    log.debug("target", $(target));
    var targetDataType = toTitleCase($(target).data("type"));
    // log.debug(targetDataType);
    // log.debug($(`.dropdown-option[data-type="${targetDataType}"]`).find('.dropdown-item-selected').text());
    $(`.dropdown-option[data-type="${targetDataType}"]`)
      .find(".dropdown-item-selected")
      .text($(target).find(".swatch-image").attr("title"));
    $(`.dropdown-option[data-type="${targetDataType}"]`)
      .find(".dropdown-item")
      .removeClass("selected");
    $(`.dropdown-option[data-type="${targetDataType}"]`)
      .find(`.dropdown-item[data-index="${$(target).data("index")}"]`)
      .addClass("selected");

    //$(target).closest('.dropdown-option').find('.dropdown-item-selected').text($(target).text());

    document
      .querySelector(`.product-select-option-${$(target).data("option") - 1}`)
      .dispatchEvent(ev);
    $(target)
      .closest(".swatches-wrapper")
      .find(".swatch")
      .removeClass("active");
    $(target).addClass("active");
    // change label to preorder if preorder set
    log.debug($(target).data("preorder"));
    let preorderT = "";
    let preorderCart = "";
    let swatchTitle = $(target).find(".swatch-image").attr("title");
    log.debug(swatchTitle);
    if ($(target).data("preorder") != undefined) {
      preorderT = $(target).data("preorder");
      preorderCart = $(target).data("preorder-message");
      $(target).closest(".desk-swatches").find(".title strong").text(preorderT);
    } else {
      $(target)
        .closest(".desk-swatches")
        .find(".title strong")
        .text($(target).find(".swatch-image").attr("title"));
    }

    self.setPreorder();
  },
  updateSwatchAriaStates: function (activeSwatch) {
    $(activeSwatch).closest(".swatches-wrapper").find(".swatch").attr("aria-pressed", "false");
    $(activeSwatch).attr("aria-pressed", "true");
  },
  triggerFirstVariant: function () {
    var self = this;
    $(".desk-swatches .swatch.active").each(function () {
      self.selectDeskSwatch(this);
    });
  },
  showLabel: function () {
    log.debug($(".bold_option_title:contains('Cable Management & Power')"));
    $(".bold_option_title:contains('Cable Management & Power')").each(
      function () {
        $(this).css("display", "block");
        $(this).css("font-size", "14px");
        $(this).css("margin-bottom", "16px");
        $(this).css("text-align", "left");
        $(this).css("margin-top", "24px");
      },
    );
  },
  events: function () {
    var self = this;
    function handleSwatchActivation(e) {
      e.preventDefault();
      log.debug(e.currentTarget);
      if ($(e.currentTarget).closest(".swatches").hasClass("desk-swatches")) {
        self.selectDeskSwatch(e.currentTarget);
      } else {
        self.selectSwatch(e.currentTarget);
      }
      self.updateSwatchAriaStates(e.currentTarget);
      self.showLabel();
    }
    $(".swatches-wrapper").on("click", ".swatch", handleSwatchActivation);
    $(".swatches-wrapper").on("keydown", ".swatch", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        handleSwatchActivation.call(this, e);
      }
    });
  },
  init: function () {
    this.triggerFirstVariant();
    this.events();
    this.showLabel();
  },
};
if (typeof prodVariants !== "undefined" && prodVariants !== null) {
  setTimeout(productSwatches.init(), 500);
}

function updateCountdown() {
  // Get current time in the New York (America/New_York) timezone
  var now = new Date();
  var options = { timeZone: "America/New_York", hour12: false };
  var nowInNewYork = new Date(now.toLocaleString("en-US", options));
  const currentHour = nowInNewYork.getHours();
  const currentDay = nowInNewYork.getDay();
  if (
    (currentDay === 6 && currentHour >= 0) ||
    currentDay === 0 ||
    (currentDay === 5 && currentHour >= 23)
  ) {
    $(".product-timer-wrapper p").html(
      "<strong>🚚  Same day</strong> dispatch on orders before 2pm.",
    );
  } else if (currentHour >= 0 && currentHour < 14) {
    const noon = new Date(now);
    noon.setHours(14, 0, 0, 0); // Set to 14:00 PM today

    const diff = noon - nowInNewYork;

    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    $(".product-timer-wrapper p").html(
      `🚚  Order in the next <strong>${hours} hours, ${minutes} minutes</strong> for same day dispatch.`,
    );
  } else {
    $(".product-timer-wrapper p").html(
      "<strong>🚚  Same day</strong> dispatch for orders before 2pm EST.",
    );
  }

  if (window.innerWidth < 768) {
    $(".bottom-products-slider").before($(".product-timer.cart-timer"));
    $(".cart-left").before($(".product-timer.cart-timer"));
  } else {
    $(".product-timer.cart-timer").prependTo(".timer-container");
  }
}

// Initial call and set interval to update every second
updateCountdown();
setInterval(updateCountdown, 1000);

function initReadMore(popupRoot = document) {
  popupRoot.querySelectorAll(".readMoreWrapper").forEach((wrapper) => {
    const content = wrapper.querySelector(".readMoreContent");
    const toggle = wrapper.querySelector(".readMoreToggle");
    if (!content || !toggle) return;
    const defaultMaxHeight = 5 * 1.5 * 16;
    const defaultLines = null;
    let readMoreText = toggle.textContent.trim() || "Read more";
    let readLessText = "Read less";
    if (toggle.dataset.readLessText) readLessText = toggle.dataset.readLessText;
    if (toggle.dataset.readMoreText) readMoreText = toggle.dataset.readMoreText;
    const maxHeight = wrapper.dataset.readMoreHeight
      ? parseInt(wrapper.dataset.readMoreHeight, 10)
      : defaultMaxHeight;
    const lines = wrapper.dataset.readMoreLines
      ? parseInt(wrapper.dataset.readMoreLines, 10)
      : defaultLines;
    const applyClamp = () => {
      if (lines) {
        content.classList.add("readMoreClamp");
        content.style.webkitLineClamp = lines;
        content.style.maxHeight = "";
        content.style.overflow = "";
      } else {
        content.classList.remove("readMoreClamp");
        content.style.webkitLineClamp = "";
        content.style.maxHeight = maxHeight + "px";
        content.style.overflow = "hidden";
      }
    };
    const removeClamp = () => {
      content.classList.remove("readMoreClamp");
      content.style.webkitLineClamp = "";
      content.style.maxHeight = "";
      content.style.overflow = "";
    };
    applyClamp();
    wrapper.classList.remove("isExpanded");
    toggle.textContent = readMoreText;
    toggle.onclick = () => {
      if (wrapper.classList.contains("isExpanded")) {
        applyClamp();
        wrapper.classList.remove("isExpanded");
        toggle.textContent = readMoreText;
      } else {
        removeClamp();
        wrapper.classList.add("isExpanded");
        toggle.textContent = readLessText;
      }
    };
  });
}


function initOptionTitleTooltips() {
  const TITLE_SELECTORS = [".swatches-content .title", ".dropdown-option-wrapper .title", ".desktop-size-tiles__title", ".bold_option_title"];
  const TOOLTIP_CLASS = "desky-option-tooltip";
  const TOOLTIP_TEXT_CLASS = "desky-option-tooltip__text";
  const HIDDEN_BOLD_OPTION_TITLES = new Set(["leg colour", "frame colour", "desk colour"]);
  let applyTimer = null;
  let observer = null;

  function normalizeOptionKey(value) {
    if (typeof value !== "string") return "";
    return value.trim().replace(/\s+/g, " ").toLowerCase();
  }

  function normalizeTooltipMap(source) {
    const normalized = {};
    if (typeof source === "string") {
      try {
        source = JSON.parse(source);
      } catch (error) {
        source = {};
      }
    }
    if (!source || typeof source !== "object") return normalized;
    Object.keys(source).forEach((rawKey) => {
      const key = normalizeOptionKey(rawKey);
      const text = typeof source[rawKey] === "string" ? source[rawKey].trim() : "";
      if (key && text) normalized[key] = text;
    });
    return normalized;
  }

  function getTooltipText(optionName) {
    const config = window.deskyOptionTooltips || {};
    const productMap = normalizeTooltipMap(config.product);
    const templateMap = normalizeTooltipMap(config.template);
    const normalizedName = normalizeOptionKey(optionName);
    return productMap[normalizedName] || templateMap[normalizedName] || "";
  }

  function extractOptionName(titleEl) {
    if (!titleEl) return "";
    const clone = titleEl.cloneNode(true);
    clone.querySelectorAll(
      ".desky-option-tooltip, .dropdown-grommet-tooltip, .desktop-size-tiles__tooltip, .bold_tooltip"
    ).forEach((node) => node.remove());

    let rawText = (clone.textContent || "").trim();
    if (!rawText) return "";
    const colonIndex = rawText.indexOf(":");
    if (colonIndex !== -1) rawText = rawText.slice(0, colonIndex);
    return rawText.replace(/[\*\u2022]+$/g, "").trim();
  }

  function buildTooltipNode(text) {
    const tooltip = document.createElement("span");
    tooltip.className = TOOLTIP_CLASS;
    tooltip.tabIndex = 0;
    tooltip.setAttribute("aria-label", text);
    tooltip.textContent = "?";

    const tooltipText = document.createElement("span");
    tooltipText.className = TOOLTIP_TEXT_CLASS;
    tooltipText.setAttribute("role", "tooltip");
    tooltipText.textContent = text;
    tooltip.appendChild(tooltipText);
    return tooltip;
  }

  function applyTooltips() {
    document.querySelectorAll(".bold_option_title").forEach((titleEl) => {
      const normalizedBoldName = normalizeOptionKey(extractOptionName(titleEl));
      if (HIDDEN_BOLD_OPTION_TITLES.has(normalizedBoldName)) {
        titleEl.style.display = "none";
      }
    });

    TITLE_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((titleEl) => {
        const tooltipText = getTooltipText(extractOptionName(titleEl));
        const existing = titleEl.querySelector("." + TOOLTIP_CLASS);

        if (!tooltipText) {
          if (existing) existing.remove();
          return;
        }

        if (existing) {
          const nestedText = existing.querySelector("." + TOOLTIP_TEXT_CLASS);
          existing.setAttribute("aria-label", tooltipText);
          if (nestedText) nestedText.textContent = tooltipText;
          return;
        }

        titleEl.appendChild(buildTooltipNode(tooltipText));
      });
    });
  }

  function scheduleApply() {
    if (applyTimer) window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(applyTooltips, 60);
  }

  scheduleApply();
  document.addEventListener("variant:change", scheduleApply);
  document.addEventListener("shopify:section:load", scheduleApply);
  document.addEventListener("shopify:section:reorder", scheduleApply);
  document.addEventListener("shopify:section:select", scheduleApply);

  observer = new MutationObserver(scheduleApply);
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initOptionTitleTooltips);
} else {
  initOptionTitleTooltips();
}
